import styles from './style.module.css';

interface ValueSkeletonProps {
    value?: string | number | null;
    fallback?: string;
    width?: number;
    height?: number;
    isLoading?: boolean;
}

export function ValueSkeleton({
    value,
    fallback = '0',
    width = 60,
    height = 16,
    isLoading = false,
}: ValueSkeletonProps) {
    if (isLoading || value === undefined || value === null) {
        return (
            <div
                className={styles.skeleton}
                style={{
                    display: 'inline-block',
                    width: `${width}px`,
                    height: `${height}px`,
                }}
            />
        );
    }

    // Safety check: ensure value is a primitive type
    // If it's an object, convert it to a string or use fallback
    const displayValue = typeof value === 'object' ? fallback : value;

    return <span>{displayValue || fallback}</span>;
}
